import type { RequestHandler } from 'msw';

import { investInsufficientFundsHandler } from './invest-insufficient-funds.handler';
import { investRateLimitedHandler } from './invest-rate-limited.handler';
import { INVEST_REFUSALS } from './invest-refusal.scenarios';
import { investSourceOfFundsRequiredHandler } from './invest-source-of-funds-required.handler';
import { projectDetailFailureHandler } from './project-detail-failure.handler';
import { PROJECT_NOT_LISTED } from './project-not-listed.scenario';

export const MARKET_PROJECT_MOCK_HANDLERS: readonly RequestHandler[] = [
  projectDetailFailureHandler,
  PROJECT_NOT_LISTED.handler,
  investRateLimitedHandler,
  investInsufficientFundsHandler,
  investSourceOfFundsRequiredHandler,
  ...INVEST_REFUSALS.map(({ handler }) => handler),
];
